import axios from 'axios'

const state = {
  collectionsList: [],
  collectionsSingle: null,
}

const getters = {
  getCollectionsList (state) {
    return state.collectionsList
  },
  getCollectionsSingle (state) {
    return state.collectionsSingle
  },
}

const mutations = {
  setCollectionsList (state, payload) {
    state.collectionsList = payload
  },
  setCollectionsSingle (state, payload) {
    state.collectionsSingle = payload
  },
  clearCollectionsSingle (state) {
    state.collectionsSingle = null
  },
}

const actions = {
  fetchFilialMenuCollectionsList ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/filialMenuCollectionsList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setCollectionsList', res.data.items)

        return res
      })
      .catch((err) => err)
  },
  fetchFilialMenuSingleCollections ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/filialMenuCollectionsSingle'](id))
      .then((res) => {
        commit('setCollectionsSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  fetchCollectionsList ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/collectionsList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setCollectionsList', res.data.items)

        return res
      })
      .catch((err) => err)
  },
  fetchSingleCollections ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/collectionsSingle'](id))
      .then((res) => {
        commit('setCollectionsSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createCollections ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/collectionsCreate'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  editCollections ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/collectionsEdit'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  deleteCollections ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/collectionsDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getCollectionsList.filter(
            (val) => val.id !== id,
          )
          commit('setCollectionsList', items)
        }

        return res
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
